var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "pt-4 pb-0", attrs: { "grid-list-md": "", id: "explorer" } },
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c("Docs"),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { shrink: "" } },
            [
              _c("v-autocomplete", {
                ref: "pdm_shortcut_input",
                staticClass: "mt-0 pt-0 grv-input pdms-input",
                attrs: {
                  dense: "",
                  clearable: "",
                  "hide-details": "",
                  disabled: _vm.loading,
                  "menu-props": {
                    closeOnContentClick: true,
                    contentClass: "grv-menu"
                  },
                  items: _vm.ordered_shortcuts,
                  label: "Points de montage"
                },
                scopedSlots: _vm._u([
                  {
                    key: "item",
                    fn: function(data) {
                      return [
                        _c(
                          "v-list-tile",
                          {
                            on: {
                              click: function($event) {
                                return _vm.onShortcutChange(data.item.value)
                              }
                            }
                          },
                          [
                            _c(
                              "v-list-tile-content",
                              [
                                _c("v-list-tile-title", [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t" +
                                      _vm._s(data.item.unc_path) +
                                      "\n\t\t\t\t\t\t\t"
                                  )
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-list-tile-action",
                              [
                                _vm.user_favorites.indexOf(data.item.value) > -1
                                  ? _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          small: "",
                                          flat: "",
                                          icon: "",
                                          color: "cyan accent-4"
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.removeUserFavorite(
                                              data.item.value
                                            )
                                          }
                                        }
                                      },
                                      [_c("v-icon", [_vm._v("star")])],
                                      1
                                    )
                                  : _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          small: "",
                                          flat: "",
                                          icon: "",
                                          color: "background lighten-2"
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            _vm.addUserFavorite(data.item.value)
                                            _vm.onShortcutChange(
                                              data.item.value
                                            )
                                            _vm.$refs.pdm_shortcut_input.blur()
                                          }
                                        }
                                      },
                                      [_c("v-icon", [_vm._v("star_outline")])],
                                      1
                                    )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ]),
                model: {
                  value: _vm.selected_shortcut,
                  callback: function($$v) {
                    _vm.selected_shortcut = $$v
                  },
                  expression: "selected_shortcut"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { grow: "" } },
            [
              _c(
                "v-combobox",
                {
                  staticClass: "my-0 pt-0 grv-input path-input",
                  attrs: {
                    dense: "",
                    "hide-details": "",
                    disabled: _vm.loading,
                    value: _vm.current_path_display,
                    "item-value": "value",
                    "item-text": "display",
                    "menu-props": {
                      closeOnContentClick: true,
                      contentClass: "grv-menu"
                    },
                    items: _vm.registered_paths,
                    label: "Chemin"
                  },
                  on: {
                    change: function($event) {
                      return _vm.onCurrentPathChange($event)
                    }
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "item",
                      fn: function(data) {
                        return [
                          _c(
                            "v-list-tile",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.onCurrentPathChange(
                                    data.item.value
                                  )
                                }
                              }
                            },
                            [
                              _c(
                                "v-list-tile-avatar",
                                { staticStyle: { "min-width": "46px" } },
                                [
                                  data.item.type === "favorite"
                                    ? _c(
                                        "v-icon",
                                        { attrs: { color: "cyan accent-4" } },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\tstar\n\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      )
                                    : data.item.type === "history"
                                    ? _c(
                                        "v-icon",
                                        { attrs: { color: "white" } },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\thistory\n\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-list-tile-title", [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(data.item.display) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              data.item.type === "favorite"
                                ? _c(
                                    "v-list-tile-action",
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            small: "",
                                            flat: "",
                                            icon: "",
                                            color: "warning"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.removeUserFavorite(
                                                data.item.value
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("v-icon", [
                                            _vm._v("delete_forever")
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ])
                },
                [
                  _c(
                    "template",
                    { slot: "prepend-inner" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "ma-0",
                          attrs: {
                            flat: "",
                            icon: "",
                            id: "nav-back-btn",
                            disabled: _vm.preventBack,
                            title: "[Ctrl + flèche gauche]"
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.navigateBack()
                            }
                          }
                        },
                        [
                          _c("v-icon", { attrs: { large: "" } }, [
                            _vm._v("chevron_left")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        {
          staticClass: "pl-1 ma-0 path-breadcrumb",
          attrs: { row: "", "align-center": "" }
        },
        [
          _vm.user_favorites.indexOf(_vm.current_path) > -1
            ? _c(
                "v-btn",
                {
                  staticClass: "ma-0",
                  attrs: { flat: "", icon: "", color: "cyan accent-4" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.removeUserFavorite(_vm.current_path)
                    }
                  }
                },
                [_c("v-icon", [_vm._v("star")])],
                1
              )
            : _c(
                "v-btn",
                {
                  staticClass: "ma-0",
                  attrs: { flat: "", icon: "", color: "background lighten-2" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.addUserFavorite(_vm.current_path)
                    }
                  }
                },
                [_c("v-icon", [_vm._v("star_outline")])],
                1
              ),
          _vm._v(" "),
          _vm.path_steps
            ? _c(
                "span",
                { attrs: { id: "path_steps" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "path-btn text-none",
                      attrs: { color: "background" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.navigateStep(1)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(_vm.path_steps.root[0]) +
                          "\n\t\t\t\t"
                      ),
                      _c("span", [_vm._v("/")]),
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(_vm.path_steps.root[1]) +
                          "\n\t\t\t"
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.path_steps.steps, function(step, index) {
                    return _c(
                      "span",
                      { key: "step" + index, staticClass: "mr-1" },
                      [
                        _c("span", [_vm._v("/")]),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            staticClass: "path-btn text-none",
                            attrs: { color: "background" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.navigateStep(index + 2)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t" + _vm._s(step) + "\n\t\t\t\t\t"
                            ),
                            index === _vm.path_steps.steps.length - 1
                              ? _c(
                                  "v-icon",
                                  {
                                    staticClass: "ml-1",
                                    attrs: { size: "20" }
                                  },
                                  [_vm._v("\n\t\t\t\t\t\trefresh\n\t\t\t\t\t")]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  })
                ],
                2
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("span", { attrs: { id: "explorer-table-top" } }),
      _vm._v(" "),
      _c("div", { ref: "explorer-table", attrs: { id: "explorer-table" } }),
      _vm._v(" "),
      _c(
        "v-layout",
        {
          staticClass: "px-2 ma-0 table-footer",
          attrs: { row: "", "align-center": "" }
        },
        [
          _c("v-text-field", {
            ref: "search_input",
            staticClass: "mt-0 pt-0 grv-input-dense search-input",
            attrs: {
              clearable: "",
              "hide-details": "",
              disabled: _vm.loading,
              "persistent-hint": "",
              placeholder: "Filtrer",
              "prepend-inner-icon": "filter_list"
            },
            on: {
              input: function($event) {
                return _vm.onSearch($event)
              },
              "click:clear": function($event) {
                return _vm.onSearch(null)
              }
            },
            model: {
              value: _vm.search,
              callback: function($$v) {
                _vm.search = $$v
              },
              expression: "search"
            }
          }),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _vm.launcher_enabled && _vm.items.length
            ? _c("div", [
                _c(
                  "div",
                  { staticClass: "text-right", attrs: { xs3: "" } },
                  [
                    _c(
                      "v-menu",
                      {
                        attrs: {
                          "offset-y": "",
                          top: "",
                          "close-on-content-click": false
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function(ref) {
                                var on = ref.on
                                return [
                                  _c(
                                    "v-btn",
                                    _vm._g(
                                      {
                                        staticClass: "text-none ma-0",
                                        attrs: {
                                          disabled: _vm.selected.length === 0,
                                          color: "primary color--text",
                                          flat: ""
                                        }
                                      },
                                      on
                                    ),
                                    [
                                      _vm.selected.length <= 1
                                        ? _c("span", [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t" +
                                                _vm._s(_vm.selected.length) +
                                                " Asset Sélectionné\n\t\t\t\t\t\t\t"
                                            )
                                          ])
                                        : _c("span", [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t" +
                                                _vm._s(_vm.selected.length) +
                                                " Asset(s) Sélectionné(s)\n\t\t\t\t\t\t\t"
                                            )
                                          ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "text-none ma-0 ml-1",
                                      attrs: {
                                        disabled: _vm.selected.length === 0,
                                        color: "primary color--text",
                                        flat: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.directDDL(_vm.selected)
                                        }
                                      }
                                    },
                                    [
                                      _c("v-icon", { staticClass: "mr-2" }, [
                                        _vm._v("send")
                                      ]),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\tEnvoyer en DDL\n\t\t\t\t\t\t"
                                      )
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2759443813
                        )
                      },
                      [
                        _vm._v(" "),
                        _c(
                          "v-list",
                          {
                            staticClass: "background darken-1",
                            attrs: { dense: "" }
                          },
                          _vm._l(_vm.selected, function(item, i) {
                            return _c(
                              "v-list-tile",
                              {
                                key: "selected" + i,
                                on: {
                                  click: function($event) {
                                    return _vm.table.deselectRow(
                                      _vm.selected_rows[i]
                                    )
                                  }
                                }
                              },
                              [
                                _c(
                                  "v-list-tile-avatar",
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { color: "primary" } },
                                      [_vm._v("check_box")]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-list-tile-content",
                                  [
                                    _c("v-list-tile-title", [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(item.name) +
                                          "\n\t\t\t\t\t\t\t\t"
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "v-list-tile-sub-title",
                                      { staticClass: "text-left" },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm._f("humanizeBytes1000")(
                                                item.size
                                              )
                                            ) +
                                            "\n\t\t\t\t\t\t\t\t"
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          }),
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.launcher_enabled && _vm.items.length
            ? _c("div", [
                _vm.multiselect
                  ? _c(
                      "div",
                      { staticClass: "text-right", attrs: { xs3: "" } },
                      [
                        _c(
                          "v-menu",
                          {
                            attrs: {
                              "offset-y": "",
                              top: "",
                              "close-on-content-click": false
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          {
                                            staticClass: "text-none ma-0",
                                            attrs: {
                                              disabled:
                                                _vm.selected.length === 0,
                                              color: "primary color--text",
                                              flat: ""
                                            }
                                          },
                                          on
                                        ),
                                        [
                                          _vm.selected.length <= 1
                                            ? _c("span", [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t" +
                                                    _vm._s(
                                                      _vm.selected.length
                                                    ) +
                                                    " Asset Sélectionné\n\t\t\t\t\t\t\t"
                                                )
                                              ])
                                            : _c("span", [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t" +
                                                    _vm._s(
                                                      _vm.selected.length
                                                    ) +
                                                    " Asset(s) Sélectionné(s)\n\t\t\t\t\t\t\t"
                                                )
                                              ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "text-none ma-0 ml-1",
                                          attrs: {
                                            disabled: _vm.selected.length === 0,
                                            color: "primary color--text",
                                            flat: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.emitSelected(
                                                _vm.selected
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { large: "" } },
                                            [_vm._v("arrow_forward")]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2626257913
                            )
                          },
                          [
                            _vm._v(" "),
                            _c(
                              "v-list",
                              {
                                staticClass: "background darken-1",
                                attrs: { dense: "" }
                              },
                              _vm._l(_vm.selected, function(item, i) {
                                return _c(
                                  "v-list-tile",
                                  {
                                    key: "selected" + i,
                                    on: {
                                      click: function($event) {
                                        return _vm.table.deselectRow(
                                          _vm.selected_rows[i]
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "v-list-tile-avatar",
                                      [
                                        _c(
                                          "v-icon",
                                          { attrs: { color: "primary" } },
                                          [_vm._v("check_box")]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("v-list-tile-title", [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t" +
                                          _vm._s(item.path) +
                                          "\n\t\t\t\t\t\t\t"
                                      )
                                    ])
                                  ],
                                  1
                                )
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _c(
                      "div",
                      { staticClass: "text-right", attrs: { xs2: "" } },
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "text-none ma-0",
                            attrs: {
                              disabled: _vm.selected.length === 0,
                              color: "primary color--text",
                              flat: ""
                            },
                            on: {
                              click: function($event) {
                                return _vm.emitSelected(_vm.selected)
                              }
                            }
                          },
                          [
                            _vm.selected[0]
                              ? _c("span", [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t" +
                                      _vm._s(_vm.selected[0].name) +
                                      "\n\t\t\t\t\t"
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("v-icon", { attrs: { large: "", right: "" } }, [
                              _vm._v("arrow_forward")
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
              ])
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: {
            scrollable: "",
            "max-width": "800px",
            transition: "dialog-transition"
          },
          model: {
            value: _vm.modal_probe.visible,
            callback: function($$v) {
              _vm.$set(_vm.modal_probe, "visible", $$v)
            },
            expression: "modal_probe.visible"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "background" },
            [
              _c(
                "v-card-title",
                {
                  staticClass:
                    "py-1 px-3 primary color--text subheading word-break-all"
                },
                [
                  _vm._v(
                    "\n\t\t\t\t" + _vm._s(_vm.modal_probe.title) + "\n\t\t\t\t"
                  ),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "my-0",
                      attrs: { flat: "", icon: "", color: "color" },
                      on: {
                        click: function($event) {
                          return _vm.openFile("show", _vm.modal_probe.title)
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("folder")])],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.modal_probe.visible
                ? _c(
                    "v-card-text",
                    { staticClass: "pa-0" },
                    [
                      _vm.modal_probe.loading
                        ? _c("v-progress-linear", {
                            attrs: { color: "primary", indeterminate: "" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.modal_probe.loading && !_vm.modal_probe.error
                        ? _c("ProbeDisplay", {
                            attrs: { probe: _vm.modal_probe.data }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-alert",
                        {
                          staticClass: "pa-2 ma-0",
                          attrs: {
                            type: "error",
                            value: _vm.modal_probe.error !== ""
                          }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(_vm.modal_probe.error) +
                              "\n\t\t\t\t"
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: {
            scrollable: "",
            width: "800px",
            transition: "dialog-transition"
          },
          model: {
            value: _vm.mkdir_dialog.show,
            callback: function($$v) {
              _vm.$set(_vm.mkdir_dialog, "show", $$v)
            },
            expression: "mkdir_dialog.show"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "background" },
            [
              _c(
                "v-card-title",
                { staticClass: "py-1 px-2 subheading background darken-1" },
                [
                  _vm._v("\n\t\t\t\tCréer un nouveau dossier\n\t\t\t\t"),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "ma-0",
                      attrs: { flat: "", icon: "" },
                      on: {
                        click: function($event) {
                          _vm.mkdir_dialog.dest_path = null
                          _vm.mkdir_dialog.dest_path_label = null
                          _vm.mkdir_dialog.show = false
                          _vm.mkdir_dialog.error = null
                          _vm.mkdir_dialog.loading = false
                          _vm.mkdir_dialog.dest_name = "_Nouveau_dossier"
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                { staticClass: "pa-2" },
                [
                  _c("v-text-field", {
                    staticClass: "grv-input",
                    attrs: { prefix: _vm.mkdir_dialog.dest_path_label },
                    model: {
                      value: _vm.mkdir_dialog.dest_name,
                      callback: function($$v) {
                        _vm.$set(_vm.mkdir_dialog, "dest_name", $$v)
                      },
                      expression: "mkdir_dialog.dest_name"
                    }
                  }),
                  _vm._v(" "),
                  _vm.mkdir_dialog.error
                    ? _c("div", { staticClass: "error--text" }, [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(_vm.mkdir_dialog.error) +
                            "\n\t\t\t\t"
                        )
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary color--text",
                        disabled: !_vm.mkdir_dialog.dest_name
                      },
                      on: {
                        click: function($event) {
                          return _vm.mkdir(
                            _vm.mkdir_dialog.dest_path,
                            _vm.mkdir_dialog.dest_name
                          )
                        }
                      }
                    },
                    [_vm._v("\n\t\t\t\t\tOK\n\t\t\t\t")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("FileReader", {
        attrs: { file_path: _vm.file_to_read },
        on: {
          close: function($event) {
            _vm.file_to_read = null
          }
        }
      }),
      _vm._v(" "),
      _c("HtmlReader", {
        attrs: { html_path: _vm.html_to_read },
        on: {
          close: function($event) {
            _vm.html_to_read = null
          }
        }
      }),
      _vm._v(" "),
      _c("Loader", { attrs: { loading: _vm.loading } }),
      _vm._v(" "),
      _c("Uploader", {
        attrs: { current_path: _vm.current_path, error_nav: _vm.error_nav },
        on: {
          refresh: function($event) {
            return _vm.onCurrentPathChange(_vm.current_path)
          }
        }
      }),
      _vm._v(" "),
      _c("DirectoryListCsvExport", {
        attrs: {
          root_path: _vm.list_dir_dialog.root_path,
          deep: _vm.list_dir_dialog.deep
        },
        on: {
          close: function($event) {
            _vm.list_dir_dialog.root_path = ""
          }
        }
      }),
      _vm._v(" "),
      _c(
        "v-menu",
        {
          attrs: {
            "position-x": _vm.context_menu.x,
            "position-y": _vm.context_menu.y,
            absolute: "",
            "offset-y": ""
          },
          model: {
            value: _vm.context_menu.show,
            callback: function($$v) {
              _vm.$set(_vm.context_menu, "show", $$v)
            },
            expression: "context_menu.show"
          }
        },
        [
          _c(
            "v-list",
            { staticClass: "background darken-1 pa-0", attrs: { dense: "" } },
            [
              _c(
                "v-subheader",
                { staticClass: "primary color--text" },
                [
                  _c(
                    "v-icon",
                    { staticClass: "mr-2", attrs: { color: "color" } },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(_vm.context_menu.title.icon) +
                          "\n\t\t\t\t"
                      )
                    ]
                  ),
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(_vm.context_menu.title.text) +
                      "\n\t\t\t"
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.context_menu.items, function(item, index) {
                return _c(
                  "v-list-tile",
                  {
                    key: index,
                    class: item.label.color,
                    on: { click: item.action }
                  },
                  [
                    _c(
                      "v-list-tile-avatar",
                      [
                        _c(
                          "v-icon",
                          { attrs: { color: item.label.color_icon } },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(item.label.icon) +
                                "\n\t\t\t\t\t"
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    item.label.loading
                      ? _c(
                          "v-list-tile-content",
                          [
                            _c("v-progress-linear", {
                              staticClass: "ma-0",
                              attrs: {
                                indeterminate: true,
                                height: 1,
                                color: item.label.color_icon
                              }
                            })
                          ],
                          1
                        )
                      : _c(
                          "v-list-tile-content",
                          [
                            _c("v-list-tile-title", [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(item.label.text) +
                                  "\n\t\t\t\t\t"
                              )
                            ])
                          ],
                          1
                        )
                  ],
                  1
                )
              })
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17d5dacf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17d5dacf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/pages/filesystem/explorer.vue
// module id = null
// module chunks = 